import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import SuppliersList from "../reports/SuppliersList";
import SuppliersListDetail from "../reports/SuppliersListDetail";
import OnlineInstallment from "../reports/TableOnlineInstallment";
import RequestDetail from "../detail/detailFindPage";
import ChequeInfo from "../chequeInfo/chequeInfo";
import LoansReport from "../reports/LoansReport";
import SalesReport from "../reports/SalesReport";

export default function ReportConfigPage() {
  const active = localStorage.getItem("setActivePage");
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect exact={true} from="/Report" to={`/Report/${active}`} />
      }

      {/* <ContentRoute
        path="/Report/SuppliersList"
        component={SuppliersList}
        label={undefined}
        children={undefined}
        render={undefined}
      /> */}
      <ContentRoute
        path="/Report/OnlineInstallment"
        component={OnlineInstallment}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Report/LoansReport"
        component={LoansReport}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Report/SalesReport"
        component={SalesReport}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      {/* <ContentRoute
        path="/Report/SuppliersList1/SuppliersListDetail"
        component={SuppliersListDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      /> */}
      <ContentRoute
        path="/Report/:activePage1/report-detail"
        component={RequestDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Report/ChequeInfoReport"
        component={ChequeInfo}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
